import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { SearchFiltersUsage } from "@graylog/enterprise-api";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const USER_FILTER_SUMMARY_QUERY_KEY = "user_filter_summary_query_key";
const useSearchFilterUsagesSummaryQuery = (filterId, options) => useQuery({
  queryKey: [USER_FILTER_SUMMARY_QUERY_KEY, filterId, "summary"],
  queryFn: () => defaultOnError(
    SearchFiltersUsage.get(filterId),
    i18n.t("notifications.load_filter_usages_summary_failed", { ns: "enterprise_search", filterId }),
    i18n.t("notifications.load_filter_usages_summary_failed_title", { ns: "enterprise_search" })
  ),
  placeholderData: keepPreviousData,
  initialData: {
    summary: []
  },
  ...options
});
export default useSearchFilterUsagesSummaryQuery;
